import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_PATHS, ROUTE_URLS } from 'router/routes'

import { ReactComponent as settingsSVG } from 'shared/img/settings-svg.svg'
import AviatorIcon from 'shared/img/slotsPreviewIcons/aviator.png'
import CasinoIcon from 'shared/img/slotsPreviewIcons/casino.png'
import LiveIcon from 'shared/img/slotsPreviewIcons/live.png'
import CasinoLiveIcon from 'shared/img/slotsPreviewIcons/live-casino.png'
import SportIcon from 'shared/img/slotsPreviewIcons/sport.png'
import WheelIcon from 'shared/img/slotsPreviewIcons/wheel.png'
import { ReactComponent as playersActivitiesSVG } from 'shared/img/user-svg.svg'

import { localeCommonKeysType, localeProfileKeysType } from 'shared/locale/en-US'

import sport1 from '../img/sport1.png'
import sport2 from '../img/sport2.png'
import sport3 from '../img/sport3.png'

export interface IProfilePageSubItem {
  route: string
  label: localeProfileKeysType
  desktopRoute: string
  notDesktop?: boolean
}

interface IProfilePageItem {
  label: localeProfileKeysType
  icon: any
  items: IProfilePageSubItem[]
}

export interface ISearchItem {
  id: string
  name: localeCommonKeysType | string
  route: string
  authRequired?: boolean
  isModal?: boolean
  imageUrl?: string
}

export const profilePageItems: Record<string, IProfilePageItem> = {
  playerActivities: {
    label: 'playersActivities',
    icon: playersActivitiesSVG,
    items: [
      {
        desktopRoute: ROUTE_URLS.DIGITAIN_SPORT_PAGE('BetsHistory'),
        route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('BetsHistory'),
        label: 'betHistory1',
      },
      {
        desktopRoute: ROUTE_URLS.BETBY_SPORT('bets'),
        route: ROUTE_URLS.BETBY_SPORT('bets'),
        label: 'betHistory2',
      },
      {
        desktopRoute: ROUTE_URLS.PROFILE_BETHISTORY(),
        route: ROUTE_URLS.PROFILE_BETHISTORY(),
        label: 'betHistory3',
      },
      {
        desktopRoute: ROUTE_URLS.PROFILE_SLOTS_HISTORY(),
        route: ROUTE_URLS.PROFILE_SLOTS_HISTORY(),
        label: 'slotsHistory',
      },
      // {
      //   desktopRoute: ROUTE_URLS.PROFILE_SPINHISTORY(),
      //   route: ROUTE_URLS.PROFILE_SPINHISTORY(),
      //   label: 'spinHistory',
      // },
      {
        desktopRoute: ROUTE_PATHS.PROFILE_TRANSACTIONS,
        route: ROUTE_PATHS.PROFILE_TRANSACTIONS,
        label: 'transactions',
      },
    ],
  },
  accountSettings: {
    label: 'accountSettings',
    icon: settingsSVG,
    items: [
      {
        desktopRoute: '',
        route: ROUTE_PATHS.PROFILE_BOOKMAKERS_SETTINGS,
        label: 'bookmakersSettings',
        notDesktop: true,
      },
      {
        desktopRoute: ROUTE_PATHS.PROFILE_USERINFO,
        route: ROUTE_PATHS.PROFILE_USERINFO,
        label: 'personalDetails',
      },
      {
        desktopRoute: ROUTE_PATHS.PROFILE_CHANGE_PASSWORD,
        route: ROUTE_PATHS.PROFILE_CHANGE_PASSWORD,
        label: 'changePassword',
      },
    ],
  },
}

export type IHomeMenuSubItem = {
  route: string
  mobileRoute?: string
  textID: localeCommonKeysType
  icon?: string
}

export interface IHomeMenuItem {
  route: string | { pathname: string; state: Record<string, any> }
  image?: string
  mobileRoute?: string
  textID: localeCommonKeysType
  authRequired?: boolean
  isModal?: boolean
  isForSideMenu?: boolean
  isForBottomHeader?: boolean
  refRoutes?: string[]
  subItems?: IHomeMenuSubItem[]
}

export const homeMenuItems: IHomeMenuItem[] = [
  {
    route: MODAL_ROUTE_URLS.CHOOSE_SPORT('sport'),
    textID: 'sport',
    image: SportIcon,
    isForBottomHeader: true,
    refRoutes: [ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'), ROUTE_URLS.BETBY_SPORT(), ROUTE_URLS.SOFTION_SPORT()],
    isModal: true,
    subItems: [
      {
        textID: 'digitain',
        route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
        icon: sport1,
      },
      {
        textID: 'betby',
        route: ROUTE_URLS.BETBY_SPORT(),
        icon: sport2,
      },
      {
        textID: 'softion',
        route: ROUTE_URLS.SOFTION_SPORT(),
        icon: sport3,
      },
    ],
  },
  {
    route: MODAL_ROUTE_URLS.CHOOSE_SPORT('liveSport'),
    textID: 'liveSport',
    image: LiveIcon,
    isForBottomHeader: true,
    isModal: true,
    refRoutes: [
      ROUTE_URLS.DIGITAIN_SPORT_PAGE('Overview'),
      ROUTE_URLS.BETBY_SPORT('live'),
      ROUTE_URLS.SOFTION_SPORT_LIVE(),
    ],
    subItems: [
      {
        textID: 'liveSport1',
        route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Overview'),
        icon: sport1,
      },
      {
        textID: 'liveSport2',
        route: ROUTE_URLS.BETBY_SPORT('live'),
        icon: sport2,
      },
      {
        textID: 'liveSport3',
        route: ROUTE_URLS.SOFTION_SPORT(),
        icon: sport3,
      },
    ],
  },
  {
    image: CasinoIcon,
    route: ROUTE_URLS.SLOTS_CASINO(),
    textID: 'casino',
  },
  {
    image: CasinoLiveIcon,
    route: ROUTE_URLS.LIVECASINO(),
    textID: 'liveCasino',
  },
  {
    image: WheelIcon,
    route: ROUTE_URLS.SLOTS_GAMETYPE('virtual'),
    textID: 'virtualGames',
  },
  {
    image: AviatorIcon,
    route: ROUTE_URLS.SLOTS_PROVIDER('otc', 'aviator_spribe'),
    textID: 'aviator',
    authRequired: true,
  },
]

export const additionalSearchOptions: ISearchItem[] = [
  {
    id: 'slots',
    name: 'slots',
    route: ROUTE_URLS.SLOTS_CASINO(),
  },
  {
    id: 'sport',
    name: 'sport',
    route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
  },
  /* {
    id: 'sport2',
    name: 'sport2',
    route: ROUTE_URLS.ALTENAR_SPORT(),
  }, */
  {
    id: 'liveCasino',
    name: 'liveCasino',
    route: ROUTE_URLS.LIVECASINO(),
  },
  {
    id: 'virtuals',
    name: 'virtuals',
    route: ROUTE_URLS.SLOTS_GAMETYPE('virtual'),
  },
]
